import { produce } from 'immer';
import { handleActions } from 'redux-actions';

import { TUserProfileFullState, initProfileFullState } from './actions';
import { UserActionTypes } from './types';

export const userProfileReducer = handleActions<TUserProfileFullState, any>(
  {
    [UserActionTypes.REQUEST_USER_PROFILE]: (state) =>
      produce(state, (draft) => {
        draft.isLoading = true;
      }),

    [UserActionTypes.REQUEST_USER_PROFILE_SUCCESS]: (state, action) =>
      produce(state, (draft) => {
        draft.isLoading = false;
        draft.profile = action.payload;
      }),
    [UserActionTypes.REQUEST_USER_PROFILE_ERROR]: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }),
    [UserActionTypes.EMAIL_USER_FORGOT_PASSWORD]: (state, action) => ({
      ...state,
      email_user_forgot_password: action.payload,
    }),
  },
  initProfileFullState,
);
